import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import globals from "../../globals";
import animations from './animations';
import NavItem from "../NavItem";
import Logo from '../Logo';
import CustomLink from "../../elements/CustomLink";
import { agentLogout } from '../../utils/agentUtil';

class NavMobile extends Component {

    constructor(props) {
        super(props);

        const isAgent = localStorage.getItem('isAgent') === 'true';
        const agentPortalUsername = localStorage.getItem('agentUsername') || '';

        this.state = {
            navItems: [],
            isAgent: isAgent,
            agentPortalUsername: agentPortalUsername,
        };
    }

    componentDidMount() {
        animations.initialise(this);
        this.setState({
            navItems: {...this.props.mainItems}
        });

        this.updateAgentStatus()
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                navItems: {...this.props.mainItems}
            });
        }
    
        this.updateAgentStatus()
    }

    updateAgentStatus () {
        const isAgent = localStorage.getItem('isAgent') === 'true';
        const agentPortalUsername = localStorage.getItem('agentUsername') || '';
    
        if (this.state.isAgent !== isAgent || this.state.agentPortalUsername !== agentPortalUsername) {
            this.setState({
                isAgent: isAgent,
                agentPortalUsername: agentPortalUsername
            });
        }
    }

    handleAgentLogout () {
        agentLogout()
        this.setState({
            isAgent: false,
            agentPortalUsername: ''
        });
    }

    handleClick(event) {
        animations.handleHamburgerClick(event, this);
    }

    handlePageChange() {
        animations.handlePageChange(this);
    }

    render() {
        const MainItems = Object.keys(this.state.navItems).map((key, index) => {
            let item = this.state.navItems[key];
            return (
                <NavItem
                    key={key}
                    identifier={key}
                    title={item.title}
                    url={item.url}
                    active={item.active}
                    children={item.children}
                    handleShowSubNav={animations.animateSubNavIn.bind(this)}
                    handlePageChange={this.handlePageChange.bind(this)}
                />
            );
        });

        const SubItems = Object.keys(this.state.navItems).map((key, index) => {
            let item = this.state.navItems[key];
            if (item.children.length === 0)
                return;

            const SubItem = item.children.map((child) => {
                return (
                    <li key={globals.convertToSlug(child.title)}>
                        <CustomLink
                            to={child.url}
                            className={child.active}
                            dangerouslySetInnerHTML={{__html: child.title}}
                            onClick={this.handlePageChange.bind(this)}
                        />
                    </li>
                );
            });

            return (
                <ul key={key} className={key + ' subnav-mobile'}>
                    {SubItem}
                </ul>
            );
        });

        return (
            <div className="mobile-nav">
                <div className="bg-slidedown-animated" />
                <div className="bg-mask"/>
                <Logo />
                <div className="mobile hamburger" onClick={this.handleClick.bind(this)} ref={(el) => this.hamburgerRef = el}>
                    <span/>
                    <span/>
                    <span/>
                    <span/>
                </div>
                <div className="nav-inner">
                    <div className="bg-placeholder">
                        <div className="subnav-heading" onClick={animations.animateSubNavOut.bind(this)} />
                    </div>
                    <ul className="main-nav">
                        {MainItems}
                    </ul>
                    {SubItems}
                    <div className="get-in-touch centered">
                    {this.state.isAgent ? 
                        <button className='agent-button' onClick={() => this.handleAgentLogout()}>
                            Not {this.state.agentPortalUsername}? Log Out
                        </button>
                    :
                        <div className="buttons">
                            <Link to="/contact" onClick={this.handlePageChange.bind(this)}>
                                <img src="/images/btn-contact-mobile.svg" alt="Contact Us" />
                            </Link>
                            <br/>
                            <Link to="/login" onClick={this.handlePageChange.bind(this)}>
                                <img src="/images/btn-login-mobile.svg" alt="Login" />
                            </Link>
                        </div>
                    }
                    </div>
                </div>
            </div>
        );
    };

}

export default NavMobile;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/NavMobile/NavMobile.js